import { ROUTE_TYPES } from '@wareclouds/frontend-common/b2c';

export const REGIONAL_HUB_ROUTE_TYPE =
  ROUTE_TYPES.REGIONAL_HUB ?? 'REGIONAL_HUB';

export const REGIONAL_HUB_SERVICE_KEY = 'REGIONAL_HUB';

export const isRegionalHubRouteType = (routeType) =>
  routeType === REGIONAL_HUB_ROUTE_TYPE;
